var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGondolaCovered(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "104px",
    height: "38px",
    viewBox: "0 0 104 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDE9Bicon/railcar/gondola_covered2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-27",
    fill: "#4F7CB4",
    cx: 95,
    cy: 34,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-28",
    fill: "#4F7CB4",
    cx: 84,
    cy: 34,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102,10 C102.276142,10 102.526142,10.1119288 102.707107,10.2928932 C102.888071,10.4738576 103,10.7238576 103,11 L103,31 L1,31 L1,11 C1,10.7238576 1.11192881,10.4738576 1.29289322,10.2928932 C1.47385763,10.1119288 1.72385763,10 2,10 Z",
    id: "Rectangle-Copy-29",
    stroke: "#4F7CB4",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9045949,1 L102.649682,10.0039544 L1.35031785,10.0039544 L4.09540509,1 L99.9045949,1 Z",
    id: "Rectangle-Copy-29",
    stroke: "#4F7CB4",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-29",
    stroke: "#4F7CB4",
    strokeWidth: 2,
    x: 28,
    y: 10,
    width: 49,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-32",
    stroke: "#4F7CB4",
    strokeWidth: 2,
    transform: "translate(52.000000, 17.000000) rotate(-270.000000) translate(-52.000000, -17.000000) ",
    x: 38,
    y: 17,
    width: 28,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-33",
    stroke: "#4F7CB4",
    strokeWidth: 2,
    transform: "translate(29.000000, 5.500000) rotate(-255.000000) translate(-29.000000, -5.500000) ",
    x: 25.5,
    y: 5.5,
    width: 7,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-34",
    stroke: "#4F7CB4",
    strokeWidth: 2,
    transform: "translate(75.000000, 5.500000) rotate(-292.000000) translate(-75.000000, -5.500000) ",
    x: 71.5,
    y: 5.5,
    width: 7,
    height: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-29",
    fill: "#4F7CB4",
    cx: 9,
    cy: 34,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-30",
    fill: "#4F7CB4",
    cx: 21,
    cy: 34,
    r: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGondolaCovered);
export default __webpack_public_path__ + "static/media/gondola_covered.ed75497dbc3bb8a7f0c1fa6ef4580939.svg";
export { ForwardRef as ReactComponent };